import React, { Component } from "react";
import Swal from "sweetalert2";
import moment from "moment";
import { Button, Divider } from "@material-ui/core";

import CustomDialog from "../layout/CustomDialog";
import CalculatorIcon from "../layout/CalculatorIcon";
import LabeledTextField from "../layout/LabeledTextField";
import thirdPartyService from "../../services/thirdPartyService";

class CalculatorDialog extends Component {
  state = {
    exchangeDate: "",
    dollarAmount: null,
    shekelAmount: null
  };

  render() {
    return (
      <CustomDialog
        label='המרת ש"ח\דולר'
        open={this.props.open}
        onClose={this.props.onClose}
        maxWidth="xs"
        paperClassName="index-calculator-dialog"
        paperStyle={{ width: 420, maxWidth: "calc(100vw - 48px)" }}
        isContentDivided={false}
        titleAlign="center"
      >
        <div className="index-calculator-body">
          <div className="index-calculator-inputs">
            <LabeledTextField
              type="date"
              value={this.state.exchangeDate}
              name="exchangeDate"
              label="תאריך המרה"
              labelWidth={120}
              textFieldWidth={160}
              onChange={(e) => this.handleOnChange(e)}
            />
            <LabeledTextField
              type="number"
              value={this.state.dollarAmount}
              name="dollarAmount"
              label="מחיר בדולר"
              labelWidth={120}
              textFieldWidth={160}
              currency="$"
              onChange={(e) => this.handleOnChange(e)}
            />
            <div className="index-calculator-action">
              <Button
                className="index-calculator-calc-btn"
                variant="contained"
                onClick={() => this.convertDollarCurrency()}
                endIcon={<CalculatorIcon />}
              >
                חשב
              </Button>
            </div>
          </div>

          <Divider className="index-calculator-divider" />

          <div className="index-calculator-results index-calculator-results-single">
            <div className="index-calculator-result">
              <LabeledTextField
                type="number"
                labeledTextFieldDirection="column"
                disabled
                value={this.state.shekelAmount}
                name="shekelAmount"
                label="מחיר בשקל"
                textFieldWidth={160}
                currency="₪"
              />
            </div>
          </div>
        </div>
      </CustomDialog>
    );
  }

  handleOnChange = (e) => {
    const newState = { ...this.state, [e.target.name]: e.target.value };
    this.setState(newState);
  };

  convertionValidations() {
    if (!this.state.dollarAmount) {
      return "מחיר בדולר הינו שדה חובה";
    } else if (!this.state.exchangeDate) {
      return "תאריך המרה הינו שדה חובה";
    } else if (this.state.exchangeDate > moment(new Date()).format("YYYY-MM-DD")) {
      return "תאריך המרה לא יכול להיות תאריך עתידי";
    }
    return null;
  }

  convertDollarCurrency() {
    const validationErr = this.convertionValidations();
    if (validationErr) {
      return Swal.fire("", validationErr, "error");
    } else {
      thirdPartyService
        .convertDollarCurrency(this.state.dollarAmount, this.state.exchangeDate)
        .then((res) => {
          this.setState({ shekelAmount: res });
        })
        .catch((err) => {
          return Swal.fire("", err, "error");
        });
    }
  }
}

export default CalculatorDialog;
